<template>
  <div id="banner-list">
    <div
      v-for="(banner, index) in bannerList"
      :key="index"
      @click="toCuration(banner.link)"
      class="banner"
    >
      <img onerror="this.classList.add('error-img')" :src="banner.img" />
      <img class="error-holder" src="@/assets/img/placholder_1200.svg" />
    </div>
    <div v-if="!bannerList.length" class="banner-null">
      <div class="img-null">
        <img src="@/assets/img/speaker.svg" />
      </div>
      <h2 class="title">優惠活動即將上線!</h2>
      <div class="sub-title">敬請您期待，我們的優惠活動即將上線！</div>
    </div>
    <div class="back">
      <v-btn class="v-btn-primary" color="primary" outlined @click="back">
        返回
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BannerList',
  components: {},
  data() {
    return {
      bannerList: [],
    }
  },
  created() {
    const banner = JSON.parse(localStorage.getItem('banners'))
    if (banner) this.bannerList.push(...banner)
  },
  methods: {
    toCuration(link) {
      this.$router.push({ name: 'curation', params: { id: link } })
    },
    back() {
      this.$router.replace({ name: 'home' })
    },
  },
}
</script>

<style lang="scss" scoped>
#banner-list {
  height: 100%;
  padding: 20px 4.8%;
  .banner {
    min-height: 150px;
    border-radius: 16px;
    overflow: hidden;
    font-size: 0;
    margin-top: 20px;
    background-color: #f3f5f8;
    img {
      width: 100%;
      &.error-img {
        display: none;
        & + .error-holder {
          display: block;
        }
      }
    }
    .error-holder {
      display: none;
    }
  }
  .banner-null {
    height: 85%;
    padding-top: 14%;
    text-align: center;
    .img-null {
      width: 30.7%;
      margin: auto;
    }
    .title {
      margin-top: 24px;
      font-size: 18px;
      font-weight: bold;
      letter-spacing: 0.56px;
      color: #383838;
    }
    .sub-title {
      margin-top: 8px;
      font-size: 14px;
      font-weight: bold;
      color: #545454;
    }
  }
  .back {
    margin-top: 20px;
  }
}
</style>
